// extracted by mini-css-extract-plugin
export default {"listItem":"TabListItem_listItem__msGwi","tab":"TabListItem_tab__mcCOQ","content":"TabListItem_content__LZetb","selected":"TabListItem_selected__nHR5R"};